module.exports = __webpack_public_path__ + "img/parameter-arrow-down.d42f2508.svg";